import { SuperAdminConstants } from '../../../_constants';

const initialState = { revokeCreditsLoading: true, data: '', error: false };

export function revokeCreditsReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_REVOKE_CREDITS:
            return {
                revokeCreditsLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_REVOKE_CREDITS:
            return {
                revokeCreditsLoading: false,
                data: action.revokeCredits,
                error: false
            };
        case SuperAdminConstants.REVOKE_CREDITS_ERROR:
            return {
                revokeCreditsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageCredits/revokeCredits.reducer.js